import * as React from 'react'
import { Platform, ScrollView } from 'react-native'
import { RootTabScreenProps } from '../../navigation/types'
import { SCREEN_MAX_WIDTH } from '../../constants/GlobalStyle'
import { TriangleHeader } from '../../components/Headers/TriangleHeader'
import CopyrightFooter from '../../components/Footers/CopyrightFooter'

import { useAppSelector } from '../../state/hooks'
import { useOrganizationStyles } from '../../hooks/useOrganizationStyles'
import { Box } from '../../components/DesignSystem/Box'
import { ORGANIZATION_TERMS_OF_USE_MAP } from './data'
import { Stack } from '../../components/DesignSystem'
import { useBreakpoints } from '../../components/DesignSystem/hooks/useBreakpoints'
import MarkDown from '../../components/MarkDown'

export default function TermsOfUseScreen({ navigation }: RootTabScreenProps<'TermsOfUse'>) {
	const { organizationLogo } = useAppSelector(state => state.data)
	const { appBackground } = useOrganizationStyles()
	const { isMobile } = useBreakpoints()

	return (
		<>
			<TriangleHeader
				logo={organizationLogo}
				background={appBackground}
				navigation={navigation}
				title={'TERMS OF USE'}
				backFunction={() => {
					if (navigation.canGoBack()) {
						navigation.goBack()
					} else {
						navigation.navigate('HomeStack', { screen: 'RestaurantSelect' })
					}
				}}
			/>
			<Box
				style={{
					flex: 1,
					maxWidth: SCREEN_MAX_WIDTH,
					marginHorizontal: 'auto',
					paddingHorizontal: isMobile ? 16 : 52,
					marginVertical: isMobile ? 16 : 32,
				}}
			>
				<ScrollView
					style={{
						backgroundColor: 'transparent',
						...(Platform.OS === 'web' && {
							scrollbarWidth: 'thin',
							scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent',
						}),
					}}
				>
					<Stack gap="xxl">
						<MarkDown content={ORGANIZATION_TERMS_OF_USE_MAP[global.org]} />
					</Stack>
				</ScrollView>
			</Box>
			{Platform.OS === 'web' && <CopyrightFooter />}
		</>
	)
}
